(() => {
	let initProductCarouselSliders = () => {
		$(".cre-t-15-flavored-categories").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}

			$(this).addClass("slider_started");
			let id = $(this).attr("id");
			let slideEl = $(this).find(".swiper-wrapper");
			let productCount = parseInt(slideEl.data("count"));
			let productCountMobile = parseInt(slideEl.data("count-mobile"));

			let prodSwiperParams = {
				loop: false,
				autoHeight: true,
				allowTouchMove: true,
				slidesPerView: productCount + 0.75,
				lazy: true,
				preloadImages: false,
				spaceBetween: 15,
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
			};

			let initProductCarouselSliders = new Swiper(
				`#${id} .product-carousel-swiper`,
				prodSwiperParams
			);

			initProductCarouselSliders.on("resize", function () {
				var windowWidth = window.innerWidth;

				if (productCount == 6) {
					if (windowWidth < 576) {
						this.params.slidesPerView = productCountMobile + 0.25;
					} else if (windowWidth < 750) {
						this.params.slidesPerView = 2.25;
					} else if (windowWidth < 1200) {
						this.params.slidesPerView = 3.75;
					} else if (windowWidth < 1360) {
						this.params.slidesPerView = 6.75;
					} else if (windowWidth < 1600) {
						this.params.slidesPerView = 5.75;
					} else {
						this.params.slidesPerView = 6.75;
					}
				} else if (productCount == 5) {
					if (windowWidth < 576) {
						this.params.slidesPerView = productCountMobile + 0.25;
					} else if (windowWidth < 750) {
						this.params.slidesPerView = 2.25;
					} else if (windowWidth < 1200) {
						this.params.slidesPerView = 3.75;
					} else if (windowWidth < 1360) {
						this.params.slidesPerView = 4.75;
					} else {
						this.params.slidesPerView = 5.75;
					}
				} else if (productCount == 4) {
					if (windowWidth < 576) {
						this.params.slidesPerView = productCountMobile + 0.25;
					} else if (windowWidth < 750) {
						this.params.slidesPerView = 2.25;
					} else if (windowWidth < 1200) {
						this.params.slidesPerView = 3.75;
					} else {
						this.params.slidesPerView = 4.75;
					}
				} else if (productCount == 3) {
					if (windowWidth < 576) {
						this.params.slidesPerView = productCountMobile + 0.25;
					} else if (windowWidth < 750) {
						this.params.slidesPerView = 2.25;
					} else {
						this.params.slidesPerView = 3.75;
					}
				} else if (productCount == 2) {
					if (windowWidth < 576) {
						this.params.slidesPerView = productCountMobile + 0.75;
					} else {
						this.params.slidesPerView = 2.75;
					}
				}
			});
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductCarouselSliders();
	});

	initProductCarouselSliders();
})();